import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/pages.css";
import Banner from "../ui/Banner";
import { getListProduct } from "../../api";
import LandingImg from "../ui/LandingImg";
import products from "../../assets/images/products.png";
import golfback from "../../assets/images/golfback2.png";

const ProductCatalog = ({ category, siblings }) => {
  const navigate = useNavigate();
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const activeTab = category.en_name.toLowerCase();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await getListProduct({ category: activeTab });
        setProductList(data.data.results ?? data.data);
        setLoading(false);
      } catch (err) {
        setError("제품 정보를 불러오는데 실패했습니다.");
        setLoading(false);
      }
    };
    fetchProducts();
  }, [activeTab]);

  const handleTabChange = (tabId) => {
    navigate(`/products/${tabId}`);
  };

  // 사업부별 배너 메타 (order 값 기준)
  const bizMeta = {
    1: {
      title: "농산업사업부",
      description: ["농가의 현실에 꼭 맞는 솔루션", "검증된 기술력으로 완성된 에코텍글로벌의 제품을 소개합니다."],
      backgroundImage: products,
    },
    2: {
      title: "첨단소재·부품사업부",
      description: ["차세대 소재와 핵심 부품 기술", "다양한 산업 분야에 혁신적인 솔루션을 제공합니다."],
      backgroundImage: products,
    },
    3: {
      title: "K-방산사업부",
      description: ["첨단 기술과 혁신적인 솔루션을 바탕으로", "대한민국 방위산업의 미래를 만들어갑니다."],
      backgroundImage: products,
    },
  };
  // 파크골프
  const categoryBannerOverrides = {
    golf: {
      title: "농산업사업부",
      description: ["탄소·아라미드 융합소재의 혁신", "라텔파크골프 클럽"],
      backgroundImage: golfback,
    },
  };
  const bizBanner = bizMeta[category.order] || bizMeta[1];
  const override = categoryBannerOverrides[activeTab];

  const bannerConfig = {
    backgroundImage: override?.backgroundImage ?? bizBanner.backgroundImage,
    title: override?.title ?? bizBanner.title,
    description: override?.description ?? bizBanner.description,
    tabs: siblings.map((cat) => ({
      id: cat.en_name.toLowerCase(),
      name: cat.name,
    })),
  };

  return (
    <div className="product-container">
      <Banner {...bannerConfig} activeTab={activeTab} onTabChange={handleTabChange} />
      <div className="productarea-section">
        {loading && <div className="loading">제품 정보를 불러오는 중...</div>}
        {error && <div className="error">{error}</div>}

        {!loading &&
          productList.map(
            (product) =>
              product.thumbnail && (
                <LandingImg key={product.id} src={product.thumbnail.file.url} />
              )
          )}

        {!loading && productList.length === 0 && (
          <div className="empty">등록된 것이 없습니다.</div>
        )}
      </div>
    </div>
  );
};

export default ProductCatalog;
